import { useEffect } from "react";
import { WorkOrder } from "@myapp/contract";
import { FieldWrapper, Input } from "../../../../shared/ui";
import { FormSection } from "../../../../shared/ui/controls/FormSection/FormSection";
import { getErrorMessage } from "../../../../shared/helpers/getErrorMessage";
import { useImmotionAuftrag } from "../model/useImmotionAuftrag";

type ImmotionAuftragSectionProps = {
  immotionAuftragId: string;
  onImmotionAuftragIdChange?: (value: string) => void;
  immotionAuftragIdError?: string;
  onAuftragLoad?: (workOrder: WorkOrder | undefined) => void;
  readonly?: boolean;
};

export const ImmotionAuftragSection = ({
  immotionAuftragId,
  onImmotionAuftragIdChange,
  immotionAuftragIdError,
  onAuftragLoad,
  readonly = false,
}: ImmotionAuftragSectionProps) => {
  const { immotionFields, workOrder, isFetching, error, handleLoadAuftrag } = useImmotionAuftrag(immotionAuftragId);

  useEffect(() => {
    onAuftragLoad?.(workOrder);
  }, [workOrder]);

  useEffect(() => {
    if (readonly && immotionAuftragId) {
      handleLoadAuftrag();
    }
  }, [readonly, immotionAuftragId]);
  const inputError = immotionAuftragIdError ?? (error ? getErrorMessage(error) : undefined);

  return (
    <FormSection title="Immotion Auftrag">
      {!readonly && (
        <div className="flex flex-row items-flex-end gap-[24px] mb-2">
          <FieldWrapper label="Auftrags-ID aus Immotion" className="flex-1 min-w-0">
            <Input
              value={immotionAuftragId}
              onChange={onImmotionAuftragIdChange}
              placeholder=""
              error={inputError}
            />
          </FieldWrapper>

          <button
            type="button"
            onClick={handleLoadAuftrag}
            disabled={isFetching}
            className="self-end bg-[#124093] text-white font-['Roboto'] text-[17px] font-medium rounded-[40px] px-[16px] py-[17px] whitespace-nowrap hover:brightness-110 transition-all leading-none disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isFetching ? "Lade..." : "Auftrag laden"}
          </button>
        </div>
      )}

      <div className="flex items-center gap-2 mb-4">
        <input
          type="checkbox"
          id="wohnungsmodernisierung"
          checked={immotionFields.isWohnungsmodernisierung}
          disabled
          className="w-4 h-4 accent-[#124093] cursor-not-allowed"
        />
        <label htmlFor="wohnungsmodernisierung" className="font-['Roboto'] text-[14px] text-[#333] select-none cursor-not-allowed">
          Wohnungsmodernisierung
        </label>
      </div>

      <div className="grid grid-cols-3 gap-x-10 gap-y-6">
        <FieldWrapper label="Wirtschaftseinheit">
          <Input value={immotionFields.wirtschaftseinheit} disabled placeholder="" />
        </FieldWrapper>

        <FieldWrapper label="Mieter">
          <Input value={immotionFields.mieter} disabled placeholder="" as="textarea" inputClassName="min-h-[90px]" />
        </FieldWrapper>

        <FieldWrapper label="Erfasser">
          <Input value={immotionFields.erfasser} disabled placeholder="" />
        </FieldWrapper>

        <FieldWrapper label="Gebäude">
          <Input value={immotionFields.hauseingang} disabled placeholder="" />
        </FieldWrapper>

        <FieldWrapper label="Gewerk">
          <Input value={immotionFields.gewerk} disabled placeholder="" />
        </FieldWrapper>

        <FieldWrapper label="Schadensbeschreibung" className="row-span-2 h-full">
          <Input
            value={immotionFields.schadensbeschreibung}
            as="textarea"
            inputClassName="flex-1 h-full"
            className="h-full"
            disabled
            placeholder=""
          />
        </FieldWrapper>

        <FieldWrapper label="Wohnung">
          <Input value={immotionFields.wohnung} disabled placeholder="" />
        </FieldWrapper>
        

        <FieldWrapper label="Leistung">
          <Input value={`${immotionFields.leistung} ${workOrder?.external.infoText ? `(${workOrder?.external.infoText})` : ''}`} disabled placeholder="" />
        </FieldWrapper>{/* 20263958 */}
           

      </div>
    </FormSection>
  );
};
